import { unloadPlan } from './plan/action'
import { unloadVacations } from './vacations/action'
import { unloadSavings } from './savings/action'
import { unloadRenovations } from './renovations/action'
import { unloadProperties } from './properties/action'
import { unloadIncomes } from './income/action'
import { unloadExpenses } from './expenses/action'
import { unloadDebt } from './debts/action'
import { unloadActivities } from './activities/action'
import { unloadReport } from './report/action'
import { unloadStats } from './stats/action'

export const unloadFutureData = () => dispatch => {
  dispatch(unloadPlan())
  dispatch(unloadVacations())
  dispatch(unloadSavings())
  dispatch(unloadRenovations())
  dispatch(unloadProperties())
  dispatch(unloadDebt())
  dispatch(unloadIncomes())
  dispatch(unloadExpenses())
  dispatch(unloadActivities())
  dispatch(unloadReport())
  dispatch(unloadStats())
}
